{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "جایگذاری",
    "pasteAsPlaintext": "جایگذاری به عنوان متن ساده",
    "pasteCharts": "جایگذاری نمودارها",
    "chartType_bar": "",
    "chartType_line": "",
    "chartType_radar": "",
    "chartType_plaintext": "",
    "selectAll": "انتخاب همه",
    "multiSelect": "یک ایتم به انتخاب شده ها اضافه کنید",
    "moveCanvas": "جابجایی بوم",
    "cut": "بریدن",
    "copy": "کپی",
    "copyAsPng": "کپی در حافطه موقت به صورت PNG",
    "copyAsSvg": "کپی در حافطه موقت به صورت SVG",
    "copyText": "کپی در حافطه موقت به صورت متن",
    "copySource": "کپی منبع در حافظه موقت",
    "convertToCode": "تبدیل به کد",
    "bringForward": "جلو آوردن",
    "sendToBack": "ارسال به عقب",
    "bringToFront": "جلو آوردن",
    "sendBackward": "پس فرستادن",
    "delete": "حذف",
    "copyStyles": "کپی سبک",
    "pasteStyles": "جایگذاری سبک",
    "stroke": "حاشیه",
    "changeStroke": "تغییر رنگ حاشیه",
    "background": "پس زمینه",
    "changeBackground": "تغییر رنگ پس زمینه",
    "fill": "رنگ آمیزی",
    "strokeWidth": "ضخامت حاشیه",
    "strokeStyle": "استایل حاشیه",
    "strokeStyle_solid": "یکدست",
    "strokeStyle_dashed": "خط چین",
    "strokeStyle_dotted": "نقطه چین",
    "sloppiness": "دقت",
    "pressure": "",
    "pressure_constant": "",
    "pressure_variable": "",
    "opacity": "شفافیت",
    "textAlign": "تراز متن",
    "edges": "لبه ها",
    "sharp": "تیز",
    "round": "گرد",
    "arrowheads": "سر پیکان",
    "arrowhead_none": "هیچ کدام",
    "arrowhead_arrow": "پیکان",
    "arrowhead_bar": "میله ای",
    "arrowhead_circle": "دایره",
    "arrowhead_circle_outline": "دایره (پیرامون)",
    "arrowhead_triangle": "مثلث",
    "arrowhead_triangle_outline": "مثلث (پیرامون)",
    "arrowhead_diamond": "الماس",
    "arrowhead_diamond_outline": "الماس (پیرامون)",
    "arrowhead_crowfoot_many": "پای کلاغی (بسیار)",
    "arrowhead_crowfoot_one": "پای کلاغی (یک)",
    "arrowhead_crowfoot_one_or_many": "پای کلاغی (یک یا بسیار)",
    "arrowhead_cardinality_one": "",
    "arrowhead_cardinality_many": "",
    "arrowhead_cardinality_one_or_many": "",
    "arrowhead_cardinality_exactly_one": "",
    "arrowhead_cardinality_zero_or_one": "",
    "arrowhead_cardinality_zero_or_many": "",
    "more_options": "امکانات بیشتر",
    "cardinality": "",
    "arrowtypes": "نوع پیکان",
    "arrowtype_sharp": "پیکان تیز",
    "arrowtype_round": "پیکان منحنی",
    "arrowtype_elbowed": "پیکان گوشه‌دار",
    "fontSize": "اندازه قلم",
    "fontFamily": "نوع قلم",
    "addWatermark": "\"ساخته شده با Excalidraw\" را اضافه کن",
    "handDrawn": "دست‌نویس",
    "normal": "عادی",
    "code": "کد",
    "small": "کوچک",
    "medium": "متوسط",
    "large": "بزرگ",
    "veryLarge": "بسیار بزرگ",
    "solid": "توپر",
    "hachure": "هاشور",
    "zigzag": "زیگزاگ",
    "crossHatch": "هاشور متقاطع",
    "thin": "نازک",
    "bold": "ضخیم",
    "left": "چپ",
    "center": "وسط",
    "right": "راست",
    "extraBold": "خیلی ضخیم",
    "architect": "معمار",
    "artist": "هنرمند",
    "cartoonist": "کارتونیست",
    "fileTitle": "نام فایل",
    "colorPicker": "انتخابگر رنگ",
    "canvasColors": "اسنفاده شده در بوم",
    "canvasBackground": "پس‌زمینه بوم",
    "drawingCanvas": "بوم نقاشی",
    "clearCanvas": "پاکسازی بوم",
    "layers": "لایه ها",
    "actions": "عملیات",
    "language": "زبان",
    "liveCollaboration": "همکاری آنلاین...",
    "duplicateSelection": "تکراری",
    "untitled": "بدون عنوان",
    "name": "نام",
    "yourName": "نام شما",
    "madeWithExcalidraw": "ساخته شده با Excalidraw",
    "group": "گروهبندی انتخابها",
    "ungroup": "حذف گروهبندی انتخابها",
    "collaborators": "همکاران",
    "you": "",
    "toggleGrid": "تغییر وضعیت خطوط شطرنجی",
    "loadingScene": "باگذاری صحنه…",
    "loadScene": "بارگذاری صحنه از فایل",
    "align": "تراز",
    "alignTop": "تراز به بالا",
    "alignBottom": "تراز به پایین",
    "alignLeft": "تراز به چپ",
    "alignRight": "تراز به راست",
    "centerVertically": "وسط قرار دادن به صورت عمودی",
    "centerHorizontally": "وسط قرار دادن به صورت افقی",
    "distributeHorizontally": "توزیع کردن به صورت افقی",
    "distributeVertically": "توزیع کردن به صورت عمودی",
    "flipHorizontal": "چرخش افقی",
    "flipVertical": "چرخش عمودی",
    "viewMode": "حالت نمایش",
    "share": "اشتراک‌گذاری",
    "showStroke": "نمایش انتخاب کننده رنگ حاشیه",
    "showBackground": "نمایش انتخاب کننده رنگ پس زمینه",
    "showFonts": "نمایش انتخاب فونت",
    "toggleTheme": "تغییر وضعیت پوسته روشن/تیره",
    "theme": "پوسته",
    "decreaseFontSize": "کاهش اندازه فونت",
    "increaseFontSize": "افزایش دادن اندازه فونت",
    "unbindText": "بازکردن نوشته",
    "bindText": "بستن نوشته",
    "createContainerFromText": "متن را در یک جایگاه بپیچید",
    "link": {
      "edit": "ویرایش لینک",
      "editEmbed": "تغیر لینک",
      "create": "افزودن لینک",
      "label": "لینک",
      "labelEmbed": "لینک و افزونه",
      "empty": "هیچ لینکی ست نشده",
      "hint": "لینک خود را بنویسید یا جایگذاری کنید",
      "goToElement": "رفتن به المان مد نظر"
    },
    "lineEditor": {
      "edit": "ویرایش لینک",
      "editArrow": "ویرایش پیکان"
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "قفل",
      "unlock": "باز کردن",
      "lockAll": "قفل همه",
      "unlockAll": "باز کردن قفل همه"
    },
    "sidebarLock": "باز نگه داشتن سایدبار",
    "selectAllElementsInFrame": "همه آیتم های در فریم را انتخاب کنید",
    "removeAllElementsFromFrame": "حذف همه آیتم های داخل فریم",
    "eyeDropper": "انتخاب رنگ از بوم",
    "followUs": "ما را دنبال کنید",
    "discordChat": "چت دیسکورد",
    "zoomToFitViewport": "بزرگنمایی به اندازه نمایشگر",
    "zoomToFitSelection": "بزرگنمایی به اندازه قسمت انتخاب شده",
    "zoomToFit": "بزرگنمایی برای دیدن تمام آیتم ها",
    "installPWA": "نصب Excalidraw روی دستگاه (PWA)",
    "autoResize": "فعالسازی تنظیم خودکار سایز",
    "imageCropping": "برش عکس",
    "unCroppedDimension": "اندازه غیر برشی",
    "copyElementLink": "کپی لینک به آیتم",
    "linkToElement": "لینک به آیتم",
    "wrapSelectionInFrame": "انتخاب را در قاب قرار دهید",
    "tab": "",
    "shapeSwitch": "",
    "preferences": "",
    "preferences_toolLock": "",
    "boxSelectionMode": "",
    "boxSelectionContain": "",
    "boxSelectionOverlap": "",
    "arrowBinding": "",
    "midpointSnapping": ""
  },
  "elementLink": {
    "title": "لینک به آیتم",
    "desc": "روی شکل یا بوم کلیک کنید، یا لینک را جایگذاری کنید.",
    "notFound": "آیتم لینک شده در بوم پیدا نشد."
  },
  "search": {
    "title": "جستجو در بوم",
    "noMatch": "هیچ موردی یافت نشد...",
    "singleResult": "نتیجه",
    "multipleResults": "نتایج",
    "placeholder": "جستجوی متن در بوم...",
    "frames": "",
    "texts": "متن"
  },
  "buttons": {
    "clearReset": "پاکسازی بوم نقاشی",
    "exportJSON": "خروجی در فایل",
    "exportImage": "خروجی گرفتن از تصویر...",
    "export": "ذخیره در...",
    "copyToClipboard": "کپی در حافظه موقت",
    "copyLink": "کپی لینک",
    "save": "ذخیره در همین فایل",
    "saveAs": "ذخیره با نام",
    "load": "باز کردن",
    "getShareableLink": "دریافت لینک قابل اشتراک",
    "close": "بستن",
    "selectLanguage": "انتخاب زبان",
    "scrollBackToContent": "به محتوا بروید",
    "zoomIn": "بزرگ نمایی",
    "zoomOut": "کوچک نمایی",
    "resetZoom": "اندازه اصلی",
    "menu": "فهرست",
    "done": "انجام شد",
    "edit": "ویرایش",
    "undo": "بازگرد",
    "redo": "از سر",
    "createNewRoom": "ایجاد یک اتاق جدید",
    "fullScreen": "تمام‌صفحه",
    "darkMode": "حالت تیره",
    "lightMode": "حالت روشن",
    "systemMode": "حالت سیستم",
    "zenMode": "حالت ذن",
    "objectsSnapMode": "به اشیاء بچسبد",
    "exitZenMode": "خروج از حالت تمرکز",
    "cancel": "لغو",
    "clear": "پاکسازی",
    "remove": "پاک کردن",
    "embed": "تغییر افزونه",
    "submit": "ارسال",
    "confirm": "تایید",
    "embeddableInteractionButton": "کلیک برای تعامل"
  },
  "alerts": {
    "clearReset": "این کار کل صفحه را پاک میکند. آیا مطمئنید؟",
    "couldNotCreateShareableLink": "عدم توانایی در ساخت یک لینک قابل اشتراک.",
    "couldNotCreateShareableLinkTooBig": "لینک قابل اشتراک گذاری ایجاد نشد: محتوای صحنه بسیار بزرگ است",
    "couldNotLoadInvalidFile": "عدم توانایی در بازگذاری فایل نامعتبر",
    "importBackendFailed": "بارگیری از پشت صحنه با شکست مواجه شد.",
    "cannotExportEmptyCanvas": "بوم خالی قابل تبدیل نیست.",
    "couldNotCopyToClipboard": "در بریده‌دان رونویسی نشد.",
    "decryptFailed": "رمزگشایی داده ها امکان‌پذیر نیست.",
    "uploadedSecurly": "آپلود با رمزگذاری دو طرفه انجام میشود، به این معنی که سرور Excalidraw و اشخاص ثالث نمی توانند مطالب شما را بخوانند.",
    "loadSceneOverridePrompt": "بارگزاری یک طرح خارجی محتوای فعلی رو از بین میبرد. آیا میخواهید ادامه دهید؟",
    "collabStopOverridePrompt": "با توقف بوم نقاشی، نقشه قبلی و ذخیره شده محلی شما را بازنویسی می کند. مطمئنی؟\n\n(اگر می خواهید نقاشی محلی خود را حفظ کنید، به سادگی برگه مرورگر را ببندید.)",
    "imageDoesNotContainScene": "به نظر نمی رسد این تصویر حاوی داده های بوم نقاشی باشد. آیا جاسازی صحنه را در حین خروجی فعال کرده اید?",
    "cannotRestoreFromImage": "صحنه را نمی توان از این فایل تصویری بازیابی کرد",
    "invalidSceneUrl": "بوم نقاشی از آدرس ارائه شده وارد نشد. این یا نادرست است، یا حاوی داده Excalidraw JSON معتبر نیست.",
    "invalidEncryptionKey": "کلید رمزگذاری باید 22 کاراکتر باشد. همکاری زنده غیرفعال است.",
    "collabOfflineWarning": "اتصال به اینترنت در دسترس نیست.\nتغییرات شما ذخیره نمی شود!",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "نوع فایل پشتیبانی نشده.",
    "imageInsertError": "عکس ارسال نشد. بعداً دوباره تلاش کنید...",
    "fileTooBig": "فایل خیلی بزرگ است حداکثر اندازه مجاز {{maxSize}}.",
    "svgImageInsertError": "تصویر SVG وارد نشد. نشانه گذاری SVG نامعتبر به نظر می رسد.",
    "failedToFetchImage": "گرفتن تصویر ناموفق بود.",
    "cannotResolveCollabServer": "به سرور collab متصل نشد. لطفا صفحه را مجددا بارگذاری کنید و دوباره تلاش کنید.",
    "collabSaveFailed": "در پایگاه داده باطن ذخیره نشد. اگر مشکلات همچنان ادامه داشت، باید فایل خود را به صورت محلی ذخیره کنید تا مطمئن شوید کار خود را از دست نمی دهید.",
    "collabSaveFailed_sizeExceeded": "در پایگاه داده بکند ذخیره نشد. اگر مشکلات همچنان ادامه داشت، باید فایل خود را به صورت محلی ذخیره کنید تا مطمئن شوید کار خود را از دست نمی دهید.",
    "imageToolNotSupported": "تصاویر غیر فعال شدند.",
    "brave_measure_text_error": {
      "line1": "به نظر می‌رسد از مرورگر Brave با تنظیم <bold> مسدود کردن شدید اثرانگشت</bold> استفاده می‌کنید.",
      "line2": "این می تواند منجر به شکستن <bold>عناصر متن</bold> در نقاشی های شما شود.",
      "line3": "اکیداً توصیه می کنیم این تنظیم را غیرفعال کنید. برای نحوه انجام این کار می‌توانید <link>این مراحل</link> را دنبال کنید.",
      "line4": "اگر غیرفعال کردن این تنظیم نمایش عناصر متنی را برطرف نکرد، لطفاً یک <issueLink>مشکل</issueLink> را در GitHub ما باز کنید یا برای ما در <discordLink>Discord</discordLink> بنویسید"
    },
    "asyncPasteFailedOnRead": "نمی تواند جاگذاری شود (نمی تواند از کلیپبورد بخواند).",
    "asyncPasteFailedOnParse": "نمیتواند جایگذاری شود.",
    "copyToSystemClipboardFailed": "نمی تواند در کلیپبورد کپی شود."
  },
  "toolBar": {
    "selection": "گزینش",
    "lasso": "",
    "image": "وارد کردن تصویر",
    "rectangle": "مستطیل",
    "diamond": "لوزی",
    "ellipse": "بیضی",
    "arrow": "پیکان",
    "line": "خط",
    "freedraw": "کشیدن",
    "text": "متن",
    "lock": "ابزار انتخاب شده را بعد از کشیدن نگه دار",
    "penMode": "حالت قلم - جلوگیری از تماس",
    "link": "افزودن/به‌روزرسانی لینک برای شکل انتخابی",
    "eraser": "پاک کن",
    "frame": "ابزار فریم",
    "embeddable": "افزونه وب",
    "laser": "اشاره گر لیزری",
    "autoshape": "",
    "bucketfill": "",
    "hand": "دست (ابزار پانینگ)",
    "extraTools": "ابزارهای بیشتر",
    "convertElementType": ""
  },
  "bucketfill": {
    "noRegion": "",
    "tooComplex": ""
  },
  "element": {
    "rectangle": "مستطیل",
    "diamond": "لوزی",
    "ellipse": "بیضی",
    "arrow": "پیکان",
    "line": "خط",
    "freedraw": "کشیدن",
    "text": "متن",
    "image": "تصویر",
    "group": "گروه",
    "frame": "قاب",
    "embeddable": "افزونه وب",
    "selection": "انتخاب",
    "iframe": "آی فریم"
  },
  "headings": {
    "canvasActions": "عملیات روی بوم",
    "selectedShapeActions": "عملیات روی شکل انتخاب شده",
    "shapes": "اشکال"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "برای چند نقطه کلیک و برای یک خط بکشید",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "کلیک کنید و بکشید و وقتی کار تمام شد رها کنید",
    "text": "نکته: با برنامه انتخاب شده شما میتوانید با دوبار کلیک کردن هرکجا میخواید متن اظاف کنید",
    "embeddable": "کلیک-درگ برای ساخت افزونه وب",
    "autoshape": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "toggleArrowhead": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "احتمالاً می‌توان این ویژگی را با تنظیم پرچم «dom.events.asyncClipboard.clipboardItem» روی «true» فعال کرد. برای تغییر پرچم های مرورگر در فایرفاکس، از صفحه \"about:config\" دیدن کنید.",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "پیش نمایش نشان داده نمی شود",
    "canvasTooBig": "بوم نقاشی بسیار بزرگ است.",
    "canvasTooBigTip": "نکته: سعی کنید دورترین عناصر را کمی به همدیگر نزدیک کنید."
  },
  "errorSplash": {
    "headingMain": "مشکلی رخ داده. امتحان کنید <button> بارگذاری مجدد صفحه </button>.",
    "clearCanvasMessage": "اگر بازنشانی صفحه مشکل را حل نکرد <button>پاک کردن بوم</button> را امتحان کنید.",
    "clearCanvasCaveat": " این باعث میشود کارهای شما ذخیره نشود ",
    "trackedToSentry": "خطا با شناسه {{eventId}} در سیستم ما رهگیری شد.",
    "openIssueMessage": "ما بسیار محتاط بودیم که اطلاعات صحنه شما را در خطا لحاظ نکنیم. اگر صحنه شما خصوصی نیست، لطفاً ما را دنبال کنید\n<button> رد یابی خطا </button>. لطفاً اطلاعات زیر را با کپی و جایگذاری در مشکل GitHub وارد کنید.",
    "sceneContent": "محتوای صحنه:"
  },
  "shareDialog": {
    "or": "یا"
  },
  "roomDialog": {
    "desc_intro": "از دیگران برای همکاری در کار خود دعوت کنید.",
    "desc_privacy": "نگران نباشید، این نشست به صورت پایانه-به-پایانه رمزنگاری شده است و کاملا امن است. حتی سرورهای ما نیز قادر به دیدن ترسیمات شما نیستند.",
    "button_startSession": "شروع جلسه",
    "button_stopSession": "پایان جلسه",
    "desc_inProgressIntro": "جلسه همکاری آنلاین در حال انجام است.",
    "desc_shareLink": "این لینک را با هر کسی که می خواهید با او همکاری کنید به اشتراک بگذارید:",
    "desc_exitSession": "با پایان دادن جلسه، شما از اتاق حذف میکند، اما می توانید به صورت محلی کار خود را با بوم ادامه دهید. توجه داشته باشید که این مورد بر سایر افراد تأثیر نمی گذارد و همچنان می توانند در نسخه خود همکاری کنند.",
    "shareTitle": "به یک جلسه همکاری زنده در Excalidraw بپیوندید"
  },
  "errorDialog": {
    "title": "خطا"
  },
  "progressDialog": {
    "title": "",
    "defaultMessage": ""
  },
  "exportDialog": {
    "disk_title": "ذخیره در دیسک",
    "disk_details": "داده های صحنه را به فایلی که بعداً می توانید از آن وارد کنید صادر کنید.",
    "disk_button": "ذخیره در فایل",
    "link_title": "لینک قابل اشتراک‌گذاری",
    "link_details": "خروجی به عنوان یک پیوند فقط خواندنی.",
    "link_button": "خروجی در فایل",
    "excalidrawplus_description": "صحنه را در فضای کاری Excalidraw+ خود ذخیره کنید.",
    "excalidrawplus_button": "خروجی گرفتن",
    "excalidrawplus_exportError": "در حال حاضر نمی‌توان به Excalidraw+ صادر کرد..."
  },
  "helpDialog": {
    "blog": "بلاگ ما را بخوانید",
    "click": "کلیک",
    "deepSelect": "انتخاب عمیق",
    "deepBoxSelect": "انتخاب عمیق در کادر، و جلوگیری از کشیدن",
    "createFlowchart": "از هر آیتمی یک فلوچارت ایجاد کنید",
    "navigateFlowchart": "پیمایش یک فلوچارت",
    "curvedArrow": "فلش خمیده",
    "curvedLine": "منحنی",
    "documentation": "مستندات",
    "doubleClick": "دابل کلیک",
    "drag": "کشیدن",
    "editor": "ویرایشگر",
    "editLineArrowPoints": "نقاط خط/پیکان را ویرایش کنید",
    "editText": "ویرایش متن / افزودن برچسب",
    "github": "اشکالی می بینید؟ گزارش دهید",
    "howto": "راهنمای ما را دنبال کنید",
    "or": "یا",
    "preventBinding": "مانع شدن از چسبیدن فلش ها",
    "tools": "ابزار",
    "shortcuts": "میانبرهای صفحه کلید",
    "textFinish": "پایان ویرایش (ویرایشگر متن)",
    "textNewLine": "افزودن خط جدید (ویرایشگر متن)",
    "title": "راهنما",
    "view": "مشاهده",
    "zoomToFit": "بزرگنمایی برای دیدن تمام آیتم ها",
    "zoomToSelection": "بزرگنمایی قسمت انتخاب شده",
    "toggleElementLock": "قفل/بازکردن انتخاب شده ها",
    "movePageUpDown": "حرکت صفحه به بالا/پایین",
    "movePageLeftRight": "حرکت صفحه به چپ/راست",
    "cropStart": "برش تصویر",
    "cropFinish": "پایان برش تصویر"
  },
  "clearCanvasDialog": {
    "title": "پاک کردن بوم"
  },
  "imageExportDialog": {
    "header": "خروجی گرفتن از تصویر",
    "label": {
      "withBackground": "پس زمینه",
      "onlySelected": "فقط انتخاب شده ها",
      "darkMode": "حالت تاریک",
      "embedScene": "صحنه افزونه",
      "scale": "نسبت",
      "padding": "فاصله"
    },
    "tooltip": {
      "embedScene": "داده های صحنه در فایل PNG/SVG صادر شده ذخیره می شود تا صحنه را بتوان از آن بازیابی کرد.\nاندازه فایل خروجی را افزایش می دهد."
    },
    "title": {
      "exportToPng": "تبدیل به PNG",
      "exportToSvg": "تبدیل به SVG",
      "copyPngToClipboard": "کپی PNG در حافظه موقت"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "کپی در حافظه موقت"
    }
  },
  "encrypted": {
    "tooltip": "شما در یک محیط رمزگزاری شده دو طرفه در حال طراحی هستید پس Excalidraw هرگز طرح های شما را نمیبند.",
    "link": "پست وبلاگ در مورد رمزگذاری سرتاسر در Excalidraw"
  },
  "stats": {
    "angle": "زاویه",
    "shapes": "اشکال",
    "height": "ارتفاع",
    "scene": "صحنه",
    "selected": "انتخاب شده",
    "storage": "حافظه",
    "fullTitle": "ویژگی‌های بوم و شکل",
    "title": "ویژگی‌ها",
    "generalStats": "عمومی",
    "elementProperties": "ویژگی‌های شکل",
    "total": "مجموع",
    "version": "نسخه",
    "versionCopy": "برای کپی کردن کلیک کنید",
    "versionNotAvailable": "نسخه غیرقابل دسترس",
    "width": "عرض"
  },
  "toast": {
    "copyStyles": "سبک کپی شد.",
    "copyToClipboard": "در کلیپ‌بورد کپی شد.",
    "copyToClipboardAsPng": "کپی {{exportSelection}} در حافظه موقت به عنوان PNG\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "{{exportSelection}} در حافظه موقت به عنوان\n({{exportColorScheme}}) رونویسی شد",
    "fileSaved": "فایل ذخیره شد.",
    "fileSavedToFilename": "ذخیره در {filename}",
    "canvas": "بوم",
    "selection": "انتخاب",
    "pasteAsSingleElement": "از {{shortcut}} برای چسباندن به عنوان یک عنصر استفاده کنید،\nیا در یک ویرایشگر متن موجود جایگذاری کنید",
    "unableToEmbed": "قرار دادن این Url در حال حاضر مجاز نیست. درGitHub برای درخواست Url Whitelisted مشکلی ایجاد کنید",
    "unrecognizedLinkFormat": "پیوندی که افزودید با قالب مورد انتظار مطابقت ندارد. لطفاً سعی کنید رشته \"افزونه\" ارائه شده توسط سایت منبع را بچسبانید",
    "elementLinkCopied": "لینک در کلیپ‌بورد کپی شد"
  },
  "colors": {
    "transparent": "شفاف",
    "black": "سیاه",
    "white": "سفید",
    "red": "قرمز",
    "pink": "صورتی",
    "grape": "یاقوتی",
    "violet": "بنفش",
    "gray": "خاکستری",
    "blue": "آبی",
    "cyan": "فیروزه‌ای",
    "teal": "سبزآبی",
    "green": "سبز",
    "yellow": "زرد",
    "orange": "نارنجی",
    "bronze": "برنزی"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "آیا می‌خواهید به جای آن به Excalidraw+ بروید؟",
      "menuHint": "خروجی، ترجیحات، زبان ها، ..."
    },
    "defaults": {
      "menuHint": "خروجی، ترجیحات، وبیشتر ...",
      "center_heading": "نمودارها .ساخته شده. ساده.",
      "toolbarHint": "ابزاری را انتخاب کنید و نقاشی را شروع کنید!",
      "helpHint": "میانبرها و راهنما"
    }
  },
  "colorPicker": {
    "color": "رنگ",
    "mostUsedCustomColors": "رنگ های به‌تازگی به‌کار گرفته شده",
    "colors": "رنگ‌ها",
    "shades": "جلوه‌ها",
    "hexCode": "کدِ هگز",
    "noShades": "هیچ سایه ای برای این رنگ در دسترس نیست",
    "invalidColor": "",
    "invalidHexLength": "",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "صادر کردن به عنوان تصاویر",
        "button": "صادر کردن به عنوان تصاویر",
        "description": "خروجی از داده های صحنه به عنوان تصویر که میتوانید بعدا بیافزایید."
      },
      "saveToDisk": {
        "title": "ذخیره در دیسک",
        "button": "ذخیره در دیسک",
        "description": "خروجی از داده های صحنه را به عنوان فایل که بعدا می توانید بیافزایید."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "خروجی به Excalidraw+",
        "description": "ذخیره صفحه در میز کار Excalidraw+."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "بارگذاری از فایل",
        "button": "بارگذاری از فایل",
        "description": "بارگذاری از فایل <bold>جایگزین بشه با محتوای موجود</bold>.<br></br> می توانید ابتدا با استفاده از یکی از گزینه های زیر از نقاشی خود نسخه پشتیبان تهیه کنید."
      },
      "shareableLink": {
        "title": "بارگذاری از پیوند",
        "button": "جایگزینی محتوای من",
        "description": "بارگذاری از فایل <bold>جایگزین بشه با محتوای موجود</bold>.<br></br> می توانید ابتدا با استفاده از یکی از گزینه های زیر از نقاشی خود نسخه پشتیبان تهیه کنید."
      }
    }
  },
  "quickSearch": {
    "placeholder": "جستجو فوری"
  },
  "fontList": {
    "badge": {
      "old": "قدیمی"
    },
    "sceneFonts": "در این صحنه",
    "availableFonts": "قلم های در دسترس",
    "empty": "قلمی یافت نشد"
  },
  "userList": {
    "empty": "کاربری یافت نشد",
    "hint": {
      "text": "روی کاربر بزنید تا دنبالش کنید",
      "followStatus": "هم‌اینک این کاربر را دنبال میکنید",
      "inCall": "کاربر در تماسی صوتی است",
      "micMuted": "میکروفون کاربر بی‌صدا است",
      "isSpeaking": "کاربر در حال صحبت است"
    }
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "Shift",
    "spacebar": "فاصله",
    "delete": "حذف",
    "mmb": ""
  }
}
